export const EXTERNAL_PLATFORM_ACTION_MESSAGE =
  'To change your reservation or purchase add-on services, please use the site where you originally booked.';
